import React from "react";
import "./Cancel_order_details_table.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Table } from "react-bootstrap";

function Cancel_order_details_table({ order, dontShowPrice }) {
  return (
    <>
      <div className="product_content_holder">
        <div className="product_content">
          <div className="product_detail_inner">
            <div className="left_side">
              <div className="img_holder">
                <img
                  src={process.env.REACT_APP_IMG_URL + order.Product?.image}
                />
              </div>

              <div className="text_holder">
                <div className="product_name">
                  <p>{order?.Product_Variant?.name}</p>
                </div>
                <div className="weight">
                  <p>
                    {order?.Product_Variant?.name} {order?.Product?.Unit?.name}
                  </p>
                </div>
              </div>
            </div>

            <div>
              <div className="qty_holder">
                <p>
                  X{order?.quantity}{" "}
                  {!dontShowPrice && (
                    <span className="price">
                      ₹{order?.total_selling_price}
                    </span>
                  )}
                </p>
              </div>
            </div>
          </div>

          <div className="addon_catagory_list_holder">
            <ul>
              <li>
                <b>Add On :</b>
                {order?.Product_Order_Detail_Addons?.map((val) => (
                  <div className="addon_text_holder">
                    <div className="product_name">
                      <h5> {val?.Addon?.name}</h5>
                    </div>
                  </div>
                ))}
              </li>
            </ul>

            {/* {props?.cartVarient?.Cart_Addon_Multiples?.map((val)=>
                    <>
                    {val?.Addon_Category?.name}:{val?.Addon?.name}
                    </>
                    )} 
                   
                    {props?.cartVarient?.Cart_Addon_Singles?.map((val)=>
                    <>
                     {val?.Addon_Category?.name}:{val?.Addon?.name}
                    </>
                    )} */}
          </div>
        </div>
      </div>

      {/* <div className='product_content_holder'>
        <div className='product_content'>
          <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.REACT_APP_IMG_URL +
                    order?.Product_Order_Details?.Product?.image
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>{order?.Product_Order_Details?.Product_Variant?.name}</p>
                </div>
                <div className='weight'>
                  <p>{order?.total_kg}</p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div>

          <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/products/img2.png"
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>Apple</p>
                </div>
                <div className='weight'>
                  <p>0.5kg</p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div>
        </div>
      </div> */}
    </>
  );
}

export default Cancel_order_details_table;
